// ソロゲーム用 AI 難易度定義（Phase 2 マトリクス実測に基づく決定、2026-04-16）
// 実測データと詳細な分析は scripts/balance/PHASE_1_2_REPORT.md 参照

export type Difficulty = 'easy' | 'normal' | 'hard' | 'hell'

export type AiEngine = 'noisy-greedy' | 'greedy' | 'minimax2' | 'minimax3' | 'noisy-minimax2'

export interface DifficultyConfig {
  readonly id: Difficulty
  readonly label: string
  readonly labelJa: string
  readonly engine: AiEngine
  // noisy-* 系のランダム手発動率（0.0〜1.0）
  readonly noiseRate?: number
  // minimax 系の読み深さ
  readonly depth?: number
  readonly description: string
}

export const DIFFICULTIES: Record<Difficulty, DifficultyConfig> = {
  easy: {
    id: 'easy',
    label: 'EASY',
    labelJa: 'おためし',
    engine: 'noisy-greedy',
    noiseRate: 0.30,
    description: 'あいてはポヤッとしてるようだ',
  },
  normal: {
    id: 'normal',
    label: 'NORMAL',
    labelJa: 'ふつう',
    engine: 'noisy-minimax2',
    depth: 2,
    noiseRate: 0.10,
    description: 'あいてがたまにポカする',
  },
  hard: {
    id: 'hard',
    label: 'HARD',
    labelJa: 'むずい',
    engine: 'greedy',
    description: 'あいての視野がひろい',
  },
  hell: {
    id: 'hell',
    label: 'HELL',
    labelJa: 'ヤバい',
    engine: 'minimax3',
    depth: 3,
    description: 'あいてがつよい 先読み上等',
  },
}

export const DEFAULT_DIFFICULTY: Difficulty = 'normal'
